import styled from 'styled-components';

const StyledLabel = styled.label<{
  display?: string;
  disabled?: boolean;
  fontSize?: string;
  boldLabel?: boolean;
  textAlign?: string;
  paddingRight?: string;
  maxWidth?: string;
  mobPaddingRight?: string;
  mobileBreakpoint?: string;
  mobFontSize?: string;
  hiddenLabel?: boolean;
  fontColor?: string;
}>`
  font-family: Open Sans;
  min-height: 30px;
  display: ${(props) => (props.display === undefined ? 'block' : props.display)};
  opacity: ${(props) => (props.disabled === undefined || !props.disabled ? '1' : '0.5')};
  font-size: ${(props) => (props.fontSize === undefined ? '16px' : props.fontSize)};
  font-weight: ${(props) => (props.boldLabel ? 'bold' : '600')};

  text-align: left;
  margin-bottom: 6px;
  flex-wrap: wrap;
  ${(props) => (props.textAlign ? `text-align: ${props.textAlign};` : null)}
  ${(props) => (props.paddingRight ? `padding-right: ${props.paddingRight};` : null)}
      ${(props) =>
    props.maxWidth
      ? `
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        max-width: ${props.maxWidth};
      `
      : null}
      & > span {
    font-weight: normal;
    opacity: ${(props) => (props.disabled === undefined || !props.disabled ? '1' : '0.5')};
  }
  ${(props) =>
    props.mobPaddingRight && props.mobileBreakpoint
      ? `
        @media screen and (max-width: ${props.mobileBreakpoint}) {
          padding-right: ${props.mobPaddingRight};
        }
      `
      : null}
  ${(props) =>
    props.mobFontSize && props.mobileBreakpoint
      ? `
        @media screen and (max-width: ${props.mobileBreakpoint}) {
          font-size: ${props.mobFontSize};
        }
      `
      : null}

      ${(props) =>
    props.hiddenLabel
      ? `
       /* accessible hidden */
      clip: rect(0 0 0 0); 
      clip-path: inset(50%);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap; 
      width: 1px;
      
      `
      : ``};
`;

export default StyledLabel;
